import { Splide } from "@splidejs/splide";
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';

const MarqueeSlider = () => {
  const targetElms = document.getElementsByClassName('js-sliderMarquee');
  if(targetElms.length === 0) return;
  Array.from(targetElms).forEach((targetElm) => {
    const splide = new Splide(targetElm, {
      type: 'loop',
      pagination: false,
      arrows: false,
      autoWidth: true,
      autoScroll: {
        speed: 1,
      },
    });
    splide.mount( { AutoScroll } );
  });
}

const CarouselSlider = () => {  
  const targetElms = document.getElementsByClassName('js-sliderCarousel');
  if(targetElms.length === 0) return;
  Array.from(targetElms).forEach((targetElm) => {
    const splide = new Splide(targetElm, {
      type: 'loop',
      perPage: 1,
      pagination: true,
      gap: '2rem',
      padding: {left: '2rem', right: '2rem'},
      arrows: true,
      autoWidth: true,
      autoplay: true,
      interval: 5000,
      speed: 500,
      pauseOnFocus: false,
      pauseOnHover: false,
      breakpoints: {
        768: {
          autoWidth: false,
          fixedWidth: "100%",
          gap: "1rem",
          padding: {left: '1rem', right: '1rem'},
        },
      }
    });
    splide.mount();
  });
};

export {MarqueeSlider, CarouselSlider};